// extracted by mini-css-extract-plugin
export default {"sectionContent":"OfferM_sectionContent__m33ds","offer":"OfferM_offer__COH0r","scroll":"OfferM_scroll__T43jF"};